import { ComponentDefinition } from '@contentful/experiences-sdk-react';

export const marketoFormExperienceDefinition: ComponentDefinition = {
  id: 'marketoFormExperienceDefinition',
  name: 'Marketo Form',
  category: 'Custom',
  thumbnailUrl: 'https://unpkg.com/lucide-static/icons/file-input.svg',
  variables: {
    formId: {
      type: 'Number',
      displayName: 'Form ID',
      validations: {
        bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
      },
    },
    thankYouUrl: {
      type: 'Text',
      displayName: 'Thank You URL',
      defaultValue: '',
      description:
        'URL to redirect to after form submission. Leave empty to show the default thank-you message.',
      group: 'content',
      validations: {
        bindingSourceType: ['manual'],
        format: 'URL',
      },
    },
  },
} as const;
